module.exports = __webpack_public_path__ + "686d22a95c985d75cad888137e85dc84.svg";